import Pipeline from "../../../../src/articles/components/360-video-pipeline";
import * as React from 'react';
export default {
  Pipeline,
  React
};